module.exports = __webpack_public_path__ + "img/idea_img6.7adb68f6.png";